import styled from "styled-components";

export const StyledServiceOrderDrawerOrderInfo = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2.4rem;
  background-color: #fff;
  /* padding: 1.2rem; */
`;

export const StyledServiceOrderDrawerOrderInfoOrderTime = styled.div`
  display: flex;
  justify-content: space-between;
  gap: 2.4rem;

  .order-time {
    color: #8c8c8c;
    font-size: 1.2rem;
    font-weight: 400;
  }
`;
export const StyledServiceOrderDrawerOrderInfoOrderDetails = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1.6rem;

  .order-details-item-row {
    display: flex;
    gap: 1.6rem;

    .order-details-item {
      color: #8c8c8c;
      font-size: 1.2rem;
      font-weight: 400;

      .order-details-item-value {
        color: #1c1726;
      }
    }
  }
`;
export const StyledServiceOrderDrawerOrderInfoOrderDetailsCustomerDetails = styled.div`
  display: flex;
  gap: 1.6rem;
`;
